import { useEffect, useRef } from 'react';

import {
  AUTH_BLOCK_CODE_DEACTIVATED,
  removeLocalStorageItem,
  setAuthBlockState,
} from '@/shared/utils';

interface UseChatSocketParams {
  isOpen: boolean;
  wsUrl: string | null;
  onMessage: (data: any) => void;
}

export const useChatSocket = ({ isOpen, wsUrl, onMessage }: UseChatSocketParams) => {
  const socketRef = useRef<WebSocket | null>(null);

  useEffect(() => {
    if (!wsUrl || !isOpen) return;

    const socket = new WebSocket(wsUrl);
    socketRef.current = socket;

    socket.onopen = () => {
      console.log('[WS] connected');
    };

    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        onMessage(data);
      } catch (e) {
        console.error('[WS] parse error', e);
      }
    };

    socket.onerror = (e) => {
      console.error('[WS] error', e);
    };

    socket.onclose = (e) => {
      console.log('[WS] closed', e.code, e.reason);
      if (e.reason === AUTH_BLOCK_CODE_DEACTIVATED) {
        removeLocalStorageItem('token');
        setAuthBlockState({
          code: AUTH_BLOCK_CODE_DEACTIVATED,
          message: 'Ваш аккаунт деактивирован',
        });
      }
    };

    return () => {
      socket.close(1000, 'unmount or wsUrl changed');
      socketRef.current = null;
    };
  }, [wsUrl, onMessage]);

  return socketRef;
};
